import React, { useState } from 'react';
import { Heart, Star, Send, Check } from 'lucide-react';
type Comment = {
  username: string;
  stars: number;
  text: string;
  likes: number;
  time: string;
};
const initialComments: Comment[] = [{
  username: '@marta.docente',
  stars: 5,
  text: "Incredibile il materiale! Ho già pianificato l'intero trimestre con i prompt del Tomo 2. Mi sento finalmente libera la domenica.",
  likes: 23,
  time: '2 ore fa'
}, {
  username: '@prof.giuseppe_72',
  stars: 5,
  text: "Il Tomo 5 sui BES e DSA è oro puro. Ho creato 3 PDP in meno di un'ora, prima ci mettevo giornate intere.",
  likes: 18,
  time: '5 ore fa'
}, {
  username: '@alessia_maestra',
  stars: 5,
  text: "Finalmente qualcuno che spiega l'intelligenza artificiale per noi docenti italiani in modo concreto. Vale ogni centesimo.",
  likes: 31,
  time: '8 ore fa'
}, {
  username: '@stefanob.scienze',
  stars: 4,
  text: 'Ottimo sistema, organizzato benissimo. Avrei voluto qualche esempio in più per matematica ma per il resto è completo.',
  likes: 7,
  time: '14 ore fa'
}, {
  username: '@giovanna.primaria',
  stars: 5,
  text: 'Stavo perdendo 3 ore a settimana su cose che ora faccio in 5 minuti. Il Bonus 4 (checklist di attivazione) è geniale.',
  likes: 14,
  time: '22 ore fa'
}];
const morePool: Comment[] = [{
  username: '@robertoc.sostegno',
  stars: 5,
  text: 'Finalmente ho superato un anno scolastico senza stress da burocrazia. Tutto organizzato, documentato, in ordine.',
  likes: 12,
  time: '1 giorno fa'
}, {
  username: '@chiara.lettere',
  stars: 5,
  text: 'Le UDA pronte in 20 minuti sono un game changer. Ho già consigliato Docente PRO a tutta la mia scuola.',
  likes: 19,
  time: '1 giorno fa'
}, {
  username: '@luca_prof_storia',
  stars: 5,
  text: 'Sembrava troppo bello per essere vero. Lo sto usando da 5 giorni e ho già recuperato 6 ore della mia settimana. Pazzesco.',
  likes: 27,
  time: '1 giorno fa'
}, {
  username: '@valentina.dirigente',
  stars: 5,
  text: 'Lo sto consigliando a tutto il collegio docenti. Investimento minimo, valore enorme. Bravissimi.',
  likes: 22,
  time: '1 giorno fa'
}, {
  username: '@andrea_matematica',
  stars: 4,
  text: 'Molto utile, soprattutto i prompt per le verifiche differenziate. Ho dimezzato davvero il tempo di correzione.',
  likes: 9,
  time: '1 giorno fa'
}, {
  username: '@sofia.infanzia',
  stars: 5,
  text: "Pensavo non fosse adatto alla scuola dell'infanzia, mi sbagliavo. Le attività creative del Tomo 3 sono fantastiche.",
  likes: 16,
  time: '2 giorni fa'
}, {
  username: '@davide.linguestraniere',
  stars: 5,
  text: 'Il sistema funziona benissimo per le lingue. Genero esercizi personalizzati per ogni livello in pochi secondi.',
  likes: 11,
  time: '2 giorni fa'
}, {
  username: '@federica.sostegno',
  stars: 5,
  text: "L'adattamento materiali per dislessia e discalculia mi ha cambiato la vita. Grazie davvero.",
  likes: 25,
  time: '2 giorni fa'
}, {
  username: '@marco.educazionefisica',
  stars: 4,
  text: 'Pratico, diretto, niente fuffa. Per finalmente avere il week-end libero vale tutto.',
  likes: 8,
  time: '2 giorni fa'
}, {
  username: '@elena.arte',
  stars: 5,
  text: "Il Tomo 6 sulla produttività è stato una rivelazione. Ho protetto il mio tempo personale e mi sento un'altra persona.",
  likes: 17,
  time: '2 giorni fa'
}];
const StarRating = ({
  value,
  onChange,
  size = 'w-7 h-7',
  interactive = false
}: {
  value: number;
  onChange?: (v: number) => void;
  size?: string;
  interactive?: boolean;
}) => <div className="flex items-center gap-1" data-id="element-220">
    {[1, 2, 3, 4, 5].map(i => <button key={i} type="button" onClick={() => interactive && onChange?.(i)} disabled={!interactive} aria-label={`${i} stelle`} className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'} ${i <= value ? 'text-gold-400' : 'text-gray-600'}`} data-id="element-221">
        <Star className={`${size} ${i <= value ? 'fill-current' : ''}`} data-id="element-222" />
      </button>)}
  </div>;
export function CommentsSection() {
  const [text, setText] = useState('');
  const [name, setName] = useState('');
  const [rating, setRating] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [extraComments, setExtraComments] = useState<Comment[]>([]);
  const [likedSet, setLikedSet] = useState<Set<string>>(new Set());
  const allComments = [...initialComments, ...extraComments];
  const visible = allComments.slice(0, visibleCount);
  const canLoadMore = visibleCount < initialComments.length + morePool.length;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim() || rating === 0) return;
    setSubmitted(true);
    setText('');
    setName('');
    setRating(0);
    setTimeout(() => setSubmitted(false), 5000);
  };
  const handleLoadMore = () => {
    const start = extraComments.length;
    const next = morePool.slice(start, start + 5);
    setExtraComments([...extraComments, ...next]);
    setVisibleCount(visibleCount + 5);
  };
  const toggleLike = (username: string) => {
    setLikedSet(prev => {
      const next = new Set(prev);
      if (next.has(username)) next.delete(username);else next.add(username);
      return next;
    });
  };
  return <section className="mb-20" data-id="element-223">
      <div className="text-center mb-10" data-id="element-224">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 uppercase tracking-tight" data-id="element-225">
          Commenti di chi ha già accesso
        </h2>
        <p className="text-gray-400" data-id="element-226">
          Lascia la tua recensione per la community di docenti italiani
        </p>
      </div>

      {/* Comment form */}
      <div className="max-w-2xl mx-auto glass-panel border-gold-500/20 rounded-2xl p-6 md:p-8 mb-10 relative" data-id="element-227">
        {submitted && <div className="absolute inset-0 z-20 flex items-center justify-center bg-dark-900/95 backdrop-blur-sm rounded-2xl border border-emerald-500/30 p-6" data-id="element-228">
            <div className="text-center" data-id="element-229">
              <div className="w-16 h-16 rounded-full bg-emerald-500/20 border border-emerald-500/40 flex items-center justify-center mx-auto mb-4" data-id="element-230">
                <Check className="w-8 h-8 text-emerald-400" data-id="element-231" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-232">
                Grazie per il tuo commento!
              </h3>
              <p className="text-gray-400 max-w-sm mx-auto" data-id="element-233">
                La tua recensione sarà pubblicata a breve dopo la moderazione.
              </p>
            </div>
          </div>}

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-234">
          <div data-id="element-235">
            <label className="block text-white font-bold mb-3" data-id="element-236">
              Lascia la tua recensione per la community:
            </label>
            <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Scrivi qui la tua esperienza con Docente PRO..." rows={4} className="w-full bg-dark-800 border border-white/10 rounded-xl p-4 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500/50 focus:ring-1 focus:ring-gold-500/30 transition-colors resize-none" required data-id="element-237" />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-238">
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Il tuo nome (opzionale)" className="flex-1 bg-dark-800 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500/50 focus:ring-1 focus:ring-gold-500/30 transition-colors text-sm" data-id="element-239" />
            <div className="flex items-center gap-3" data-id="element-240">
              <span className="text-gray-400 text-sm font-medium" data-id="element-241">Valuta:</span>
              <StarRating value={rating} onChange={setRating} interactive size="w-6 h-6" data-id="element-242" />
            </div>
          </div>

          <button type="submit" disabled={!text.trim() || rating === 0} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-xl bg-gold-500 hover:bg-gold-400 text-dark-900 font-bold uppercase tracking-wider text-sm transition-all duration-200 hover:-translate-y-0.5 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:translate-y-0 shadow-lg shadow-gold-500/20" data-id="element-243">
            <Send className="w-4 h-4" data-id="element-244" />
            Pubblica
          </button>
        </form>
      </div>

      {/* Comments list */}
      <div className="max-w-2xl mx-auto space-y-4" data-id="element-245">
        {visible.map((c, i) => {
        const liked = likedSet.has(c.username);
        const likeCount = c.likes + (liked ? 1 : 0);
        return <div key={`${c.username}-${i}`} className="glass-panel rounded-2xl p-5 md:p-6 border-white/5 hover:border-white/10 transition-colors" data-id="element-246">
              <div className="flex items-start justify-between gap-3 mb-2" data-id="element-247">
                <div className="flex items-center gap-3 min-w-0" data-id="element-248">
                  <div className="w-10 h-10 rounded-full bg-gold-500/15 border border-gold-500/30 flex items-center justify-center text-gold-400 font-bold shrink-0" data-id="element-249">
                    {c.username.charAt(1).toUpperCase()}
                  </div>
                  <span className="text-gold-400 font-bold truncate" data-id="element-250">
                    {c.username}
                  </span>
                </div>
                <StarRating value={c.stars} size="w-4 h-4" data-id="element-251" />
              </div>

              <p className="text-gray-200 leading-relaxed mb-3 text-[15px]" data-id="element-252">
                {c.text}
              </p>

              <div className="flex items-center gap-5 text-sm" data-id="element-253">
                <button onClick={() => toggleLike(c.username)} className={`flex items-center gap-1.5 transition-colors ${liked ? 'text-red-400' : 'text-gray-500 hover:text-gray-300'}`} aria-label={liked ? 'Togli mi piace' : 'Metti mi piace'} data-id="element-254">
                  <Heart className={`w-4 h-4 ${liked ? 'fill-current' : ''}`} data-id="element-255" />
                  <span className="font-medium" data-id="element-256">{likeCount} Likes</span>
                </button>
                <span className="text-gray-500" data-id="element-257">{c.time}</span>
              </div>
            </div>;
      })}

        {canLoadMore && <div className="flex justify-center pt-4" data-id="element-258">
            <button onClick={handleLoadMore} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-dark-800 border border-white/10 hover:border-gold-500/30 text-white font-semibold transition-colors" data-id="element-259">
              Carica altri 5 commenti
            </button>
          </div>}
      </div>
    </section>;
}